import { render } from "./upd-email-address.vue?vue&type=template&id=71211622&scoped=true"
import script from "./upd-email-address.vue?vue&type=script&lang=js"
export * from "./upd-email-address.vue?vue&type=script&lang=js"

import "./upd-email-address.vue?vue&type=style&index=0&id=71211622&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71211622"]])

export default __exports__